var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i-select',{attrs:{"filterable":true,"clearable":_vm.clearable,"value":_vm.value},on:{"input":_vm.input}},_vm._l((_vm.list),function(i){return _c('i-option',{key:i.id,attrs:{"value":i.id,"label":i.name}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }